/*
 *
 * PayByLinkFirstActivationPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 27-Mar-2025
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import PayByLinkFirstActivationPopup from './PayByLinkFirstActivationPopup'
import { doShowPopup, doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  doShowPopup: (type) => dispatch(doShowPopup(type)),
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PayByLinkFirstActivationPopup)
